import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Icon, IconColors, Icons, TableIconText } from '../../../global';
import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { MatProgressBar } from '@angular/material/progress-bar';
import { LoaderComponent } from '../loader/loader.component';
import { MatTooltip } from '@angular/material/tooltip';
import { ButtonIconComponent } from '../buttons/button-icon/button-icon.component';
import { TranslatePipe } from '@ngx-translate/core';
import { FileSizePipe } from '../../pipes/file-size.pipe';

@Component({
    selector: 'slm-document-item',
    templateUrl: 'document-item.component.html',
    styleUrls: ['./document-item.component.scss'],
    imports: [NgIf, SvgIconComponent, NgSwitch, NgSwitchCase, MatProgressBar, LoaderComponent, MatTooltip, ButtonIconComponent, TranslatePipe, FileSizePipe]
})
export class DocumentItemComponent {
  public readonly icon = Icon;
  @Output() public fireEvent = new EventEmitter<string>();

  @Input() progress = 0;
  @Input() file: File = null;
  @Input() name = '';
  @Input() hideOpen = false;
  @Input() hideClose = false;
  @Input() ocrColumn: TableIconText = null;
  @Input() ocrStatus: number = 0

  @Input('status')
  public set setStatus(status: string) {
    this.status = status;
    this.setStyle();
    switch (status) {
      case 'canceled':
        this.buttonIcon = Icon.REFRESH;
        this.tooltipLabel = 'LBL_UPLOAD_FILL.UPLOAD_DIALOG.REFRESH_DOC';
        this.iconColor = IconColors.GREY;
        break;
      case 'uploading':
        this.buttonIcon = Icon.CLOSE;
        this.tooltipLabel = 'LBL_UPLOAD_FILL.UPLOAD_DIALOG.CANCEL';
        break;
      case 'error':
        this.tooltipLabel = 'LBL_UPLOAD_FILL.UPLOAD_DIALOG.REFRESH_DOC';
        this.buttonIcon = Icon.REFRESH;
        break;
      case 'done':
        this.tooltipLabel = 'LBL_UPLOAD_FILL.UPLOAD_DIALOG.DELETE_DOC';
        this.buttonIcon = Icon.DELETE;
        break;
      case 'timeout':
        this.tooltipLabel = 'LBL_UPLOAD_FILL.UPLOAD_DIALOG.RESUME_DOC';
        this.buttonIcon = Icon.UPLOAD_FILE;
        break;
    }
  }

  public typeIcon: Icons = Icon.DESCRIPTION;
  public buttonIcon: Icons = Icon.CLOSE;
  public iconColor = '#0000FF';
  public tooltipLabel = '';
  public status = '';

  public setStyle() {
    if (this.file) {
      const fileType = this.file.type.split('/')[1];
      switch (fileType) {
        case 'pdf':
          this.typeIcon = Icon.INSERT_DRIVE_FILE;
          this.iconColor = IconColors.RED;
          break;
        case 'png':
          this.typeIcon = Icon.PHOTO;
          this.iconColor = IconColors.ORANGE;
          break;
        case 'jpg':
          this.typeIcon = Icon.PHOTO;
          this.iconColor = IconColors.BLUE;
          break;
        case 'jpeg':
          this.typeIcon = Icon.PHOTO;
          this.iconColor = IconColors.BLUE;
          break;
      }
    }
  }

  buttonClicked(action: string = null) {
    if (action === 'open') {
      this.fireEvent.emit('open');
      return;
    }
    switch (this.status) {
      case 'canceled':
        this.fireEvent.emit('refresh');
        break;
      case 'uploading':
        this.fireEvent.emit('cancel');
        break;
      case 'error': case 'timeout':
        this.fireEvent.emit('refresh');
        break;
      case 'done':
        this.fireEvent.emit('remove');
    }
  }
}
